import React from 'react';
import type { SVGProps } from 'react';
const SvgExternalLink = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}>
        <g clipPath="url(#external_link_svg__a)">
            <path d="M10.873 10.682v5.398H1.92V7.126h5.398l1.92-1.92H0V18h12.793V8.762l-1.92 1.92Z" />
            <path d="M18 9.939V0H8.06v1.92h6.662l-9.135 9.135 1.358 1.358 9.135-9.135v6.66H18Z" />
        </g>
        <defs>
            <clipPath id="external_link_svg__a">
                <path fill="#fff" d="M0 0h18v18H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default SvgExternalLink;
